import { createContext } from "react";
export const successContext = createContext(null);
